export { default as Tabs } from 'Components/Tabs/Tabs'
export { default as LoginTab } from 'Components/Tabs/LoginTab'
export { default as RegistrationTab } from 'Components/Tabs/RegistrationTab'
export { default as RegistrationTeaserTab } from 'Components/Tabs/RegistrationTeaserTab'
export { default as ContactDataTab } from 'Components/Tabs/ContactDataTab'
export { default as SocialLogin } from 'Components/Tabs/SocialLogin'

